import {FC, useEffect, useState} from "react";
import {OfficeFormData, OfficeFormProps} from "../../../../../types/office";
import {Form, Input, UploadFile} from "antd";
import Uploader from "../../../../uploader/Uploader";
import * as BUCKETS from "../../../../../enums/buckets";
import "./style.less"
import TextEditor from "../../../../text-editor/TextEditor";
import {getImageLink} from "../../../../../helpers/mainHelpers";

const OfficeForm: FC<OfficeFormProps> = (props) => {
  const {officesController} = props
  const {selectedOffice, officeForm} = officesController
  const [mainImage, setMainImage] = useState<UploadFile<any>[]>([])
  const [images, setImages] = useState<UploadFile<any>[]>([])
  const [officeDetail, setOfficeDetail] = useState(selectedOffice?.about)

  useEffect(() => {
    if (selectedOffice) {
      const formData = {
        name: selectedOffice.name,
        about: selectedOffice.about
      }

      const mainImageFile = {
        uid: selectedOffice.mainImage,
        name: "image",
        url: getImageLink({imageId: selectedOffice.mainImage, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedOffice.mainImage}
      }
      const galleryImages = selectedOffice?.images.map((imageId) => {
        return {
          uid: imageId,
          name: "image",
          url: getImageLink({imageId: imageId, bucketId: BUCKETS.MAIN}),
          response: {$id: imageId}
        }
      })
      setImages(galleryImages)
      setMainImage([mainImageFile])
      officeForm.setFieldsValue(formData)
    } else {
      officeForm.resetFields()
      setMainImage([])
      setImages([])
      setOfficeDetail("")
    }
  }, [selectedOffice])


  const onFinishHandler = (data: OfficeFormData) => {
    const correctData = {
      ...data,
      mainImage: mainImage.length === 1 ? mainImage[0].response?.$id : "",
      images: images.map(image => image.response?.$id),
      about: officeDetail || "",
    }
    officesController.formSubmitHandler(correctData)
  }
  return <Form className="office_form" layout="vertical" form={officeForm}
               onFinish={onFinishHandler}>
    <Form.Item label="Головне фото">
      <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={mainImage} setFiles={setMainImage}/>
    </Form.Item>
    <Form.Item name="name" label="Назва кабінету" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
    <Form.Item name="about" label="Детальна інформація">
      <TextEditor value={officeDetail} setValue={setOfficeDetail}/>
    </Form.Item>
    <Form.Item label="Галерея">
      <Uploader bucketId={BUCKETS.MAIN} files={images} setFiles={setImages}/>
    </Form.Item>

  </Form>
}

export default OfficeForm